import type { GuideCategory } from "./types";

/**
 * Guide Hub categories (Task #4409). Each category groups editorial articles
 * and gets its own indexable page at /guides/category/<slug>.
 */
export const GUIDE_CATEGORIES: GuideCategory[] = [
  {
    slug: "hiring-guides",
    title: "Rent a car guides",
    description:
      "Practical, no-nonsense guides to renting a classic car: how it works, what it costs, insurance, and how to choose the right car for your trip.",
    metaTitle: "Classic Car Rental Guides: How It Works, Costs & Tips | {brandName}",
    metaDescription:
      "Everything you need to hire a classic car with confidence: how booking works, what it costs, insurance and deposits, and how to pick the right car.",
    hero: {
      image: "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1920&q=80",
      alt: "Classic convertible parked on an open country road",
    },
  },
  {
    slug: "occasions",
    title: "Occasions & events",
    description:
      "Inspiration and planning guides for the moments that deserve a classic, including weddings, anniversaries, milestone birthdays, film shoots, and corporate events.",
    metaTitle: "Classic Cars for Weddings, Events & Special Occasions | {brandName}",
    metaDescription:
      "Plan the perfect entrance: guides to classic wedding cars, anniversary gifts, film and TV picture cars, and standout corporate-event hires.",
    hero: {
      image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1920&q=80",
      alt: "Vintage wedding car decorated with ribbon outside a venue",
    },
  },
  {
    slug: "destinations",
    title: "Destinations & road trips",
    description:
      "Where to point the bonnet next: scenic routes, classic-friendly cities, and road-trip itineraries built for open-top motoring.",
    metaTitle: "Classic Car Road Trips & Driving Destinations | {brandName}",
    metaDescription:
      "Plan an unforgettable drive: the best classic-car road trips and driving destinations across the UK and Europe, with routes, stops, and the cars to do them in.",
    hero: {
      image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1920&q=80",
      alt: "Classic car on a winding coastal mountain road",
    },
  },
  {
    slug: "model-guides",
    title: "Model guides",
    description:
      "Hire and buyer's guides to the most-loved classic cars: what each icon is like to drive, who it suits, and what to know before you book one for the day.",
    metaTitle: "Classic Car Model Guides: Hire & Buyer's Guides | {brandName}",
    metaDescription:
      "In-depth hire and buyer's guides to classic car icons, including the Jaguar E-Type, Porsche 911, VW camper and more. Learn what they're like to drive and how to hire one.",
    hero: {
      image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1920&q=80",
      alt: "Detail of a polished classic sports car badge and chrome",
    },
  },
];

const BY_SLUG = new Map(GUIDE_CATEGORIES.map((c) => [c.slug, c]));

export function getGuideCategory(slug: string): GuideCategory | undefined {
  return BY_SLUG.get(slug);
}
